<template>
  <div class="contents">
   <div class="inner">
      <TabMenu :menuList="menuItems" @changeTitle="handleTabChange" />
      <Differentiation v-if="selectedTab === 'differentiation'" />
      <Introduction v-if="selectedTab === 'introduction'" />
      <Security v-if="selectedTab === 'security'" />
      <Technology v-if="selectedTab === 'technology'" />
    </div>
  </div>
</template>

<script>
  import TabMenu from '../components/common/TabMenu.vue';
  import Differentiation from '../components/o2oService/Differentiation.vue';
  import Introduction from '../components/o2oService/Introduction.vue';
  import Security from '../components/o2oService/Security.vue';
  import Technology from '../components/o2oService/Technology.vue';
  export default {
    name: 'App',
    components: {
        TabMenu,
        Differentiation,
        Introduction,
        Security,
        Technology
    },
    data() {
      return {
        menuItems: [
          { key: 'introduction', name: 'O2O Service Introduction', route: '/introduction' },
          { key: 'differentiation', name: 'Differentiation', route: '/differentiation' },
          { key: 'technology', name: 'Technology', route: '/technology' },
          { key: 'security', name: 'Security', route: '/security' }
        ],
        selectedTab: 'introduction'
      }
    },
    mounted() {
        this.selectedTab = this.$route.query.name != "" && this.$route.query.name != null ? this.$route.query.name : 'introduction';
    },
    created() {
      this.country = localStorage.getItem("country");
      this.place = localStorage.getItem("place");
    },
    methods: {
      handleTabChange(tabKey) {
        this.selectedTab = tabKey; // 선택한 탭의 key 값으로 업데이트
      }
    },
    watch: {
      '$route.query'(newQuery) {
        this.selectedTab = newQuery.name != "" && newQuery.name != null ? newQuery.name : 'introduction';
      }
    },
  }
</script>
